import React from 'react';
import { CHART_COLORS } from '../../modules/reports/constants/chart-colors';

// Tooltip data interface
interface TooltipData {
  x: number;
  y: number;
  data: Array<{
    key: string;
    y: number;
    color: string;
  }>;
}

// Series data interface for tooltip
interface SeriesDataItem {
  key: string;
  value: number;
  color: string;
}

interface CustomTooltipContentActivityChartProps {
  data: TooltipData | null;
  color: string;
}

export const CustomTooltipContentActivityChart: React.FC<CustomTooltipContentActivityChartProps> = ({
  data,
  color,
}) => {
  if (!data) return null;

  const date = new Date(data.x);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  const formattedDate = `${day}.${month}.${year}`;
  const formattedTime = `${hours}:${minutes}`;

  // Get the series data
  const seriesData: SeriesDataItem[] = data.data.map((item) => ({
    key: item.key,
    value: Math.round(item.y),
    color:
      item.key === 'Clicks'
        ? CHART_COLORS.activity.clicks
        : item.key === 'Key Press'
          ? CHART_COLORS.activity.keyPress
          : CHART_COLORS.activity.mouseActivity,
  }));

  return (
    <div className="p-3 rounded-md shadow-lg bg-card border">
      <div className="text-sm font-semibold text-gray-800 mb-2 border-b pb-1">
        {formattedDate} {formattedTime}
      </div>
      <div className="space-y-2">
        {seriesData.map((series, i) => (
          <div key={i} className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="w-3 h-3 mr-2 rounded" style={{ backgroundColor: series.color }} />
              <span className="text-sm text-gray-700 font-medium">{series.key}:</span>
            </div>
            <span className="text-sm font-bold ml-3">{series.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
